// import { niceSelect } from "niceselectwithsabuj";
// import niceSelect from "niceselectwithsabuj";
import niceSelect from "niceselectwithsabuj";
import React, { useEffect } from "react";
import ImageView from "../components/ImageView";
import ScrollTop from "../components/ScrollTop";
import VideoPopup from "../components/VideoPopup";
import { animation } from "../utils";
import Footer from "./footers/Footer";
import Header from "./headers/Header";

const Layouts = ({
  children,
  noBg,
  extraCls,
  noHeader,
  noFooter,
  headernumber,
}) => {
  useEffect(() => {
    animation();
    niceSelect({ withoutwide: true });
  }, []);

  return (
    <div className={`page-wrapper${headernumber ? "" : " has-fixed-header"}`}>
      <ImageView />
      <VideoPopup />
      {!noHeader && <Header headernumber={headernumber} />}
      {children}
      {!noFooter && <Footer noBg={noBg} extraCls={extraCls} />}
      <ScrollTop />
    </div>
  );
};
export default Layouts;
